// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactDom from "react-dom";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function fromRef(param) {
  let current = param.current;
  return Stdlib_Option.map(Stdlib_Option.map((current == null) ? undefined : Primitive_option.some(current), prim => ReactDom.findDOMNode(prim)), prim => prim);
}

let setDomElementStyleProp = ((domElement, styleProp, value) =>  domElement.style[styleProp] = value);

function ReactDomElement$Spread(props) {
  return React.cloneElement(props.children, props.props);
}

let Spread = {
  make: ReactDomElement$Spread
};

function toOptionalDomElement(prim) {
  return Primitive_option.fromNullable(prim.current);
}

function focus(prim) {
  prim.focus();
}

function blur(prim) {
  prim.blur();
}

function selectionStart(prim) {
  return Primitive_option.fromNullable(prim.selectionStart);
}

function setSelectionRange(prim0, prim1, prim2) {
  prim0.setSelectionRange(prim1, prim2);
}

export {
  fromRef,
  toOptionalDomElement,
  focus,
  blur,
  selectionStart,
  setSelectionRange,
  setDomElementStyleProp,
  Spread,
}
/* react Not a pure module */
